<template>
  <svg
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 0C4.0295 0 0 4.02943 0 9C0 13.9706 4.0295 18 9 18C13.9705 18 18 13.9706 18 9C18 4.02943 13.9705 0 9 0ZM12.1106 9.47707L7.61062 12.2896C7.51957 12.3464 7.41604 12.375 7.3125 12.375C7.2187 12.375 7.12477 12.3517 7.03976 12.3044C6.86095 12.2053 6.75 12.0171 6.75 11.8125V6.1875C6.75 5.98289 6.86095 5.79473 7.03976 5.69559C7.21856 5.59589 7.4372 5.60194 7.61062 5.71043L12.1106 8.52293C12.275 8.62594 12.375 8.80611 12.375 9C12.375 9.19389 12.275 9.3741 12.1106 9.47707Z"
      :fill="fill"
    ></path>
  </svg>
</template>

<script setup lang="ts">
interface IProps {
  width?: number;
  height?: number;
  fill?: string;
  hoverFill?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  width: 18,
  height: 18,
  fill: "#56AC49",
  hoverFill: "#4B4B4B",
});
</script>

<script lang="ts">
export default {};
</script>
